// Cross-tenant CompagnyMeta-read by CompagnyID-veld.
// Null-veilig — geen listener als id ontbreekt.
//
// Gebruikt door de signup-flow om branding (Logo/SecundairyColor/etc.) van
// een partner-tenant te lezen via Partners/{slug}.networkCompagnyID.
// Spec: docs/features/onboarding-flow.md sectie "AI TOC-strategie" (Optie A).

import { useEffect, useState } from 'react'
import { db } from '../firebase/config'

const useCompagnyMetaById = (compagnyId) => {

    const [doc, setDoc] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {

        if (!compagnyId) {
            setDoc(null)
            setLoading(false)
            return
        }

        setLoading(true)

        const unsub = db.collection('CompagnyMeta')
            .where('CompagnyID', '==', compagnyId)
            .limit(1)
            .onSnapshot(
                (snap) => {
                    const first = snap.docs[0]
                    setDoc(first ? { ...first.data(), docid: first.id } : null)
                    setLoading(false)
                },
                (err) => {
                    console.error('useCompagnyMetaById error for', compagnyId, err)
                    setDoc(null)
                    setLoading(false)
                }
            )

        return () => unsub()

    }, [compagnyId])

    return { compagnyMeta: doc, loading }

}

export default useCompagnyMetaById
